import styled from "styled-components";
import { BlobBlock, Title } from "./index-styled";
import { CircleButton } from "_c/button";

export const Block = styled(BlobBlock)`
  height: 160px;
`;

export const Li = styled.li`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  font-size: 12px;
  color: var(--color-cta);
  @media (max-width: 575px) {
    justify-content: flex-start;
  }
`;
export const Text = styled.span`
  color: var(--color-cta);
`;
export const EnhancedTitle = styled(Title)`
  margin-bottom: 30px;
  @media (max-width: 575px) {
    margin-bottom: 15px;
  }
`;
export const RemoveButton = styled(CircleButton).attrs({
  small: true,
  negative: true,
})`
  margin-inline-end: 5px;
`;
